import axios from 'axios'
import history from '../history'
import { getPerfilUsuario } from './user';

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};

async function autenticador(email, senha, dispatch) {
    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/account/signin',
        {
            "email": email,
            "password": senha
        },
        {
            headers: HEADERS
        }).then(response => {
            successLogin(response, dispatch);
        }).catch(erro => {
            erroLogin(erro.response, email, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

export default autenticador;

function successLogin(response, dispatch) {
    localStorage.setItem(process.env.REACT_APP_TOKENUSER, response.data.token);
    getPerfilUsuario(dispatch)
}

function erroLogin(erro, email, dispatch) {
    if (erro !== undefined && erro.status === 406) {
        dispatch({
            type: 'OPEN_ATIVAR_CONTA',
            idUser: erro.data.id,
            email: email,
        })
    } else if (erro !== undefined && (erro.status === 403 || erro.status === 400)) {
        localStorage.removeItem(process.env.REACT_APP_TOKENUSER);
        dispatch({ type: 'OPEN_ERRO_LOGIN', erro_response: erro })
    }
}
